import React, { useState } from "react";
import {
    CardCvcElement,
    CardExpiryElement,
    CardNumberElement,
    useElements,
    useStripe
} from '@stripe/react-stripe-js';

const OneTimeSubscriptionComponent = ({ dependent, paymentMethod, onProceed, onCancel, loading, activationFee }) => {
    const [useExisting, setUseExisting] = useState(paymentMethod ? true : false);
    const [cardErrorMsg, setCardErrorMsg] = useState('');
    const [expiryErrorMsg, setExpiryErrorMsg] = useState('');
    const [cvcErrorMsg, setCvcErrorMsg] = useState('');
    const stripe = useStripe();
    const elements = useElements();

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (useExisting) {
            onProceed({ useExisting: true });
        } else {
            if (!stripe || !elements) return;
            const card = elements.getElement(CardNumberElement);
            const payload = await stripe.createPaymentMethod({
                type: 'card',
                card,
            });
            if (payload.error) {
                setCardErrorMsg(payload.error.message);
            } else {
                onProceed({ useExisting: false, paymentMethod: payload.paymentMethod });
            }
        }
    };

    return (
        <div className="fullWidth height100 marginTop30 paddingBottom100 billingFormWrap">
            <form onSubmit={handleSubmit} className="df billingForm fcol" autoComplete="off">
                <div className="titleWithSidebar df">
                    <span className="cursorPointer backArrow" onClick={onCancel} >
                     <svg className='marginRight10' width="11" height="16" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.652 16.5323C10.3215 15.8818 10.3355 14.8104 9.68334 14.1426L4.19094 8.5042L9.82931 3.01176C10.4988 2.3613 10.5128 1.28991 9.86065 0.622118C9.21019 -0.047358 8.13868 -0.0614097 7.47089 0.590778L0.621993 7.26237C-0.0474648 7.91283 -0.0615151 8.98422 0.590655 9.65201L7.26225 16.5009C7.91271 17.1704 8.98421 17.1844 9.652 16.5323Z" fill="#112e53" />
                     </svg></span>
                    <h3 className="paddingLeft35 myAccountTitle marginTop10">Dependent Activation</h3>
                </div>
                
                <div className="fullWidth">
                    <h3 className="paddingLeft35 marginTop30 generalInfoSubTitle fullWidth">Activation Details</h3>
                </div>

                <div className="billingBox fullWidth">
                    {/* Dependent Info */}
                    <div className="formRow fullWidth">
                        <label>Dependent Name</label>
                        <div className="fullWidth borderBotom paddingBottom5">
                            <strong className="head24">{dependent?.first_name} {dependent?.last_name}</strong>
                        </div>
                    </div>

                    <div className="formRow fullWidth marginTop30">
                        <label>Case number</label>
                        <div className="fullWidth borderBotom paddingBottom5">
                            <strong className="head24">{dependent?.case_file_number || dependent?.case_file_num || 'N/A'}</strong>
                        </div>
                    </div>

                    <div className="formRow fullWidth marginTop30">
                        <label>Activation Cost</label>
                        <div className="fullWidth billingAmountNew">
                            <strong className="head24">${activationFee || "..."}</strong>
                        </div>
                        <div className="fullWidth priceUsCurrencyText marginTop10 paddingLeft10">
                            Prices are mentioned in US currency and do not include applicable taxes
                        </div>
                    </div>
                </div>

                <div className="fullWidth">
                    <h3 className="paddingLeft35 marginTop30 generalInfoSubTitle fullWidth">Payment Method</h3>
                </div>

                <div className="fullWidth billingBox">
                    {paymentMethod && (
                        <div className="formRow fullWidth marginBottom40">
                            <label className="chkBox df aic cursorPointer">
                                <input 
                                    type="checkbox" 
                                    className="checkboxCustom" 
                                    checked={useExisting} 
                                    onChange={(e) => setUseExisting(e.target.checked)} 
                                />
                                <span className="paddingleft16" style={{ fontSize: '18px', color: '#112e53' }}>Use existing payment method</span>
                            </label>
                        </div>
                    )}

                    {useExisting && paymentMethod ? (
                        <div className="formRow fullWidth marginTop30">
                        <label>Card Number</label>
                        <div className="fullWidth paddingBottom5">
                            <strong className="head24">**** **** **** {paymentMethod.card_last4}</strong>
                        </div>
                    </div>
                    ) : (
                        <>
                            <div className="formRow fullWidth marginTop10">
                                <label>CARD NUMBER</label>
                                <div className="fullWidth">
                                    <div className="fullWidth">
                                        <CardNumberElement 
                                            options={{
                                                iconStyle: "solid",
                                                showIcon: true,
                                                style: { base: { fontWeight: 400, fontSize: '24px' } }
                                            }} 
                                            onChange={(e) => setCardErrorMsg(e.error ? e.error.message : '')}
                                        />
                                    </div>
                                    {cardErrorMsg && <div className="errorRelativeRow"><p className="errorMessage">{cardErrorMsg}</p></div>}
                                </div>
                            </div>

                            <div className="formRow fullWidth marginTop30 payRow">
                                <div className="width50 paddingRight16 positionRelative">
                                    <label>EXPIRES</label>
                                    <div className="fullWidth">
                                        <CardExpiryElement 
                                            options={{ style: { base: { fontWeight: 400, fontSize: '22px' } } }} 
                                            onChange={(e) => setExpiryErrorMsg(e.error ? e.error.message : '')}
                                        />
                                        {expiryErrorMsg && <div className="errorRelativeRow"><p className="errorMessage">{expiryErrorMsg}</p></div>}
                                    </div>
                                </div>
                                <div className="width50 paddingleft16 positionRelative paidTo">
                                    <label className="minWidht190 textAlignRight paddingRight16">CVC</label>
                                    <div className="fullWidth">
                                        <CardCvcElement 
                                            options={{ style: { base: { fontWeight: 400, fontSize: '22px' } } }} 
                                            onChange={(e) => setCvcErrorMsg(e.error ? e.error.message : '')}
                                        />
                                        {cvcErrorMsg && <div className="errorRelativeRow"><p className="errorMessage">{cvcErrorMsg}</p></div>}
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>

                {/* Action Buttons */}
                <div className="fullWidth textAlignRight signUpFlowButtonRow marginBottom30 displayFlexCol">
                    <div className="widthAuto">
                        <input 
                            className="backButton" 
                            type="button" 
                            onClick={onCancel} 
                            value="Back" 
                            disabled={loading} 
                        />
                    </div>
                    <div className="widthAuto marginLeft20">
                        <div className="loaderSpinner">
                            {loading && <div className="dot-pulse"></div>}
                            <input 
                                className={loading ? "saveButtonDisable buttonHeight56" : "saveButton buttonHeight56"} 
                                type="submit" 
                                value="Finish" 
                                disabled={loading || !activationFee}
                            />
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default OneTimeSubscriptionComponent;
